// extracted by mini-css-extract-plugin
module.exports = {"form":"AddGroupsModal_form__18CYe","select":"AddGroupsModal_select__VUXQl"};